import { Dimensions } from 'types';
import { ViewportHeight, ViewportWidth } from 'utils/measurement';
import { VideoClip } from '../../types';

export function getVideoPlacementDimensions(
  videoClip: VideoClip,
): Dimensions<ViewportHeight, ViewportWidth> {
  if (videoClip?.placement) {
    return videoClip.placement;
  }

  return {
    width: new ViewportWidth(parseFloat(videoClip?.original?.style?.width)),
    height: new ViewportHeight(parseFloat(videoClip?.original?.style?.height)),
    left: new ViewportWidth(parseFloat(videoClip?.original?.position?.left)),
    top: new ViewportHeight(parseFloat(videoClip?.original?.position?.top)),
  };
}
